import React from 'react';
// Router
import { BrowserRouter as Router } from 'react-router-dom';
import Routes from 'routes/';
// App Context
import { AppContext } from 'context/AppContext';
// Auth Context
import { useAuthState } from 'context/AuthContext';
// Event Context
import { EventContext } from 'context/EventContext';
// Event Context
import { PackSiteContext } from 'context/PackSiteContext';
import { SalesOrderContext } from 'context/SalesOrderContext';
// Components
import Header from 'components/Header/';
import Footer from 'components/Footer';
// Pages
import Login from 'pages/Login/';

function AppLayout() {
  const { auth } = useAuthState();
  if (!auth) return <Login />
  return (
    <Router>
      <AppContext>
        <EventContext>
          <PackSiteContext>
            <SalesOrderContext>
              <Header />
              <main className="root__content">
                <Routes />
              </main>
              <Footer />
            </SalesOrderContext>
          </PackSiteContext>
        </EventContext>
      </AppContext>
    </Router>
  );
}

export default AppLayout;
